export default __webpack_public_path__ + "static/media/bmb-4-l.00382ab1.png";